import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "plan-content" }
const _hoisted_2 = { class: "plan-general-details" }
const _hoisted_3 = { class: "plan-general-detail-container" }
const _hoisted_4 = { class: "plan-general-detail-line" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", null, " Participant ID ", -1)
const _hoisted_6 = { class: "plan-general-detail-container" }
const _hoisted_7 = { class: "plan-general-detail-line" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h5", null, " Current Coverage Status ", -1)
const _hoisted_9 = { class: "plan-general-detail-container" }
const _hoisted_10 = { class: "plan-general-detail-line" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h5", null, " Current Coverage Period ", -1)
const _hoisted_12 = {
  key: 0,
  class: "plan-general-detail-container"
}
const _hoisted_13 = { class: "plan-general-detail-line" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h5", null, " Frozen R-MRP Balance ", -1)
const _hoisted_15 = { class: "contributions-table-item" }
const _hoisted_16 = { class: "contributions-table-item-header" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h4", null, " Coverage History ", -1)
const _hoisted_18 = { class: "btn btn-secondary plan-modal" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Coverage Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Carrier Code"),
    /*#__PURE__*/_createElementVNode("th", null, "Effective Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Term/Susp"),
    /*#__PURE__*/_createElementVNode("th", null, "Reason")
  ])
], -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "8" }, "No coverage history found")
], -1)
const _hoisted_23 = [
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DaysWorkedCarousel = _resolveComponent("DaysWorkedCarousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("h4", null, _toDisplayString($setup.planSummary.PersonID), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("h4", null, _toDisplayString($setup.planSummary.Coverage.Plan), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("h4", null, _toDisplayString($setup.planSummary.Coverage.From) + " to " + _toDisplayString($setup.planSummary.Coverage.To), 1)
        ])
      ]),
      ($setup.rmrpBalance > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("h4", null, _toDisplayString($setup.formatCurrency($setup.rmrpBalance)), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("p", _hoisted_18, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.openModal('coverage-history', 'Coverage History', 'plan-coverage-history')), ["prevent"]))
          }, "See all Coverage History")
        ])
      ]),
      _createElementVNode("table", null, [
        _hoisted_19,
        ($setup.planSummary.CoverageHistory.length > 0)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.planSummary.CoverageHistory, (coverage) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: coverage.CoverageID
                }, [
                  _createElementVNode("td", null, _toDisplayString(coverage.FundName || 'N/A'), 1),
                  _createElementVNode("td", null, _toDisplayString(coverage.CarrierCode || 'N/A'), 1),
                  _createElementVNode("td", null, _toDisplayString(coverage.EffectiveDate), 1),
                  _createElementVNode("td", null, _toDisplayString(coverage.TerminationDate), 1),
                  _createElementVNode("td", null, _toDisplayString(coverage.TerminationReason || 'N/A'), 1)
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("tbody", _hoisted_21, _hoisted_23))
      ])
    ]),
    (!$setup.loading)
      ? (_openBlock(), _createBlock(_component_DaysWorkedCarousel, {
          key: 0,
          items: $setup.workPerMonthArray,
          startingMonth: $setup.planSummary.StartingMonth,
          "is-available-for-claim": $setup.isAvailableForClaim,
          "other-coverages": $setup.planSummary.OtherCoverages
        }, null, 8, ["items", "startingMonth", "is-available-for-claim", "other-coverages"]))
      : _createCommentVNode("", true)
  ]))
}